import { FC, useContext } from "react";
import { GenericAlternativeProps } from "./PharmacyResultsList.props";
import { ThemeSelectorContext } from "@/context/index";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { Button } from "capitalrx-components-2.0/lib/general";
import { ReactComponent as PrescriptionBackgroundIcon } from "@/static/images/prescription-background.svg";

import styles from "./PharmacyResultsList.module.scss";

const GenericAlternativeCard: FC<GenericAlternativeProps> = ({ genericAlternative, switchToGeneric }: GenericAlternativeProps) => {
  const { client } = useContext(ThemeSelectorContext);

  const genericButtonClassname = client ? styles.SearchGenericButtonWhitelabel : "";

  if (genericAlternative && genericAlternative?.[0]?.pharmacy?.name) {
    const generic = genericAlternative[0];
    const genericAlternativeDrugName = generic.drug.genericAlternativeDrugName;

    return (
      <div className={styles.GenericAlternative} data-testid="generic-alternative-card">
        <Paragraph className={styles.GenericAlternativeHeader} testId="generic-alternative-card-header">
          Your brand search results are below, but choosing a generic could save you even more!
        </Paragraph>
        <div className={styles.GenericAlternativeContent}>
          <div className={styles.GenericAlternativeContentDrug}>
            <PrescriptionBackgroundIcon />
            <Paragraph testId="generic-alternative-card-name">{genericAlternativeDrugName}</Paragraph>
          </div>
          <Button
            style={{ backgroundColor: "green", color: "white" }}
            appearance="primary"
            className={genericButtonClassname}
            onClick={switchToGeneric}
            testId="generic-alternative-card-search">
            SEARCH GENERIC
          </Button>
        </div>
      </div>
    );
  }
  return null;
};

export default GenericAlternativeCard;
